import styled from "styled-components";

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  background-color: #FAFAFA;
`;

export const Header = styled.div`
  padding: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  background: white;
  border-bottom: 1px solid #E5E5E5;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BackButton = styled.button`
  position: absolute;
  left: 20px;
  border: none;
  background: none;
  padding: 8px;
  cursor: pointer;
  color: #333;
  font-size: 20px;
  display: flex;
  align-items: center;
`;

export const ContentWrap = styled.div`
  flex: 1;
  padding: 24px 24px 100px;
  display: flex;
  flex-direction: column;
`;

export const ProfileImageSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 0 10px;
`;

export const ProfileImageContainer = styled.div`
  position: relative;
  width: 160px;
  height: 160px;
`;

export const ProfileImageWrapper = styled.div`
  width: 160px;
  height: 160px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #E0E0E0;
  cursor: pointer;
`;

export const ProfileImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const AddPhotoButton = styled.button`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #999;
  border: 4px solid #FAFAFA;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #777;
  }

  &::before {
    content: '+';
    font-size: 28px;
    font-weight: 400;
    color: #000;
    line-height: 1;
  }
`;

export const Label = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #000;
  margin-bottom: 8px;
  margin-top: 24px;
  text-align: left;

  &:first-of-type {
    margin-top: 0;
  }
`;

export const InfoBox = styled.div`
  width: 100%;
  height: 52px;
  padding: 0 20px;
  border: none;
  border-radius: 10px;
  background-color: #EBEBEB;
  font-size: 15px;
  color: #666;
  display: flex;
  align-items: center;
`;

export const BottomButton = styled.button`
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 48px);
  max-width: 432px;
  height: 52px;
  border: none;
  font-weight: 600;
  font-size: 16px;
  background-color: #1FBC70;
  border-radius: 12px;
  color: white;
  cursor: pointer;

  &:hover {
    background-color: #18a860;
  }

  &:active {
    background-color: #159150;
  }

  &:disabled {
    background-color: #D9D9D9;
    cursor: not-allowed;
  }
`;
